import Banner from "molecules/banner";
import React from "react";
import resourceImage from '../../assets/resources/Resources-bg.jpg'
const ResourcesBanner = () => {
  return (
    <>
      <Banner
        bannerImage={resourceImage}
        mainHeading="Resources"
        subHeading="Knowledge, insights, news, and stories from the grassroots at your fingertips."
        buttonText=""
        category="resources"
        customClass="pb-5"
      />
    </>
  );
};

export default ResourcesBanner;
